import IContentDialogService from "features/shared/components/contentDialog/IContentDialogService";
import { useInjection } from "infrastructure/ioc/ioc.react";
import { IocTypes } from "infrastructure/ioc/ioc.types";
import React from "react";
import { useTranslation } from "react-i18next";
import ContractingInfoSubDialog from "features/contracting/components/ContractingInfoSubDialog";
import { ContractingInfoSubDialogProps } from "features/contracting/models/ContractingInfoSubDialogProps";

//#region models
export interface ContractingDialogHookResult {
  openInfoDialog: (
    dialogTitle: string,
    dialogProps: ContractingInfoSubDialogProps
  ) => void;
  closeInfoDialog: () => void;
}
//#endregion models

export const useContractingDialog = (
  translationPrefix: string = "contractingInfoSubDialog"
): ContractingDialogHookResult => {
  //#region DI
  const dialogService = useInjection<IContentDialogService>(
    IocTypes.ContentDialogService
  );
  //#endregion DI

  //#region translations
  const tLabels = useTranslation("contracting\\contracting").t;
  //#endregion translations

  //#region handlers
  const openInfoDialogHandler = (
    dialogTitle: string,
    dialogProps: ContractingInfoSubDialogProps
  ) => {
    const { type, message, primaryBtn, secondaryBtn } = dialogProps;

    let props: ContractingInfoSubDialogProps = {
      type: type,
      message: tLabels(`${translationPrefix}.${message}`),
      primaryBtn: {
        text: tLabels(`${translationPrefix}.${primaryBtn.text}`),
        action: primaryBtn.action,
      },
    };

    if (secondaryBtn) {
      props.secondaryBtn = {
        text: tLabels(`${translationPrefix}.${secondaryBtn.text}`),
        action: secondaryBtn.action,
      };
    }

    const title = tLabels(`${translationPrefix}.${dialogTitle}`);

    dialogService.openDialog(
      title,
      () => React.createElement(ContractingInfoSubDialog, props),
      false,
      false
    );
  };

  const closeInfoDialogHandler = () => {
    dialogService.closeDialog();
  };
  //#endregion handlers

  //#region result
  return {
    openInfoDialog: openInfoDialogHandler,
    closeInfoDialog: closeInfoDialogHandler,
  };
  //#endregion result
};
